import React from 'react';
import PropTypes from 'prop-types';
import classSet from 'classnames';

// styles
import css from './button.sss';


export const Button = (props) => {
    const totalClasses = classSet(
        css.root,
        {
            [css.themeDarkBlue]: props.theme === 'dark-blue',
            [css.themeWhite]: props.theme === 'white',
            [css.typeContour]: props.typeContour,
            [css.stateDisabled]: props.disabled,
            [css.stateLoading]: props.isLoading,
        },
    );

    return (
        <button
            name={props.name}
            className={totalClasses}
            type={props.type}
            disabled={props.disabled}
            data-qaid={props.dataQa}
            onClick={(props.disabled || props.isLoading) ? null : props.onClick}
        >
            <span className={css.text}>{props.children}</span>
        </button>
    );
};

Button.propTypes = {
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    typeContour: PropTypes.bool,
    name: PropTypes.string,
    type: PropTypes.string,
    theme: PropTypes.string,
    onClick: PropTypes.func,
    dataQa: PropTypes.string,
};

Button.defaultProps = {
    type: 'button',
    theme: 'dark-blue'
};
